import { AppActionTypes } from 'store/action-types';

export interface State {
  language: 'en' | 'de';
}

const initialState: State = {
  language: 'de',
};

const userReducer = (state = initialState, action: AppActionTypes.Action): State => {
  const { type } = action;

  switch (type) {
    case AppActionTypes.ActionType.TOGGLE_LANGUAGE:
      return handleToggleLanguage(state);

    default:
      return state;
  }
};

function handleToggleLanguage(state: State): State {
  return { ...state, language: state.language === 'en' ? 'de' : 'en' };
}

export default userReducer;
